import { Breakpoints, colors, getFontStyle, spacing } from '@cabonline/ui-shared';
import styled from '@emotion/styled';

const labelHeight = `${spacing.m}px`;

/**
 * On mobile, filters stack full-width (list-filter-wrapper wraps them) so each
 * select's menu — sized relative to its own control — stays within the viewport
 * instead of the fixed min-width overflowing a narrow, content-sized pill.
 */
export const StyledMultiSelectContainer = styled.div`
  @media (max-width: ${Breakpoints.Mobile}px) {
    width: 100%;
  }
`;

export const StyledErrorWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: ${labelHeight};
  margin-bottom: 4px;
`;

export const StyledErrorText = styled.div`
  ${getFontStyle('s', 'semi')};
  color: ${colors.red};
  padding-left: 4px;
`;

export const StyledOptionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;

  /* Let the label (a Text "p") shrink and ellipsize instead of wrapping onto multiple lines. */
  > p {
    flex: 1;
    min-width: 0;
  }
`;

export const StyledMenuHeader = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${colors.gray3};
  padding: 4px 8px;
  gap: 8px;
`;

export const StyledSearchInputWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  gap: 6px;
`;

export const StyledSearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  color: ${colors.black};
  background: transparent;
  padding: 6px 0;
  &::placeholder {
    color: ${colors.gray2};
  }
`;

export const StyledSelectAllButton = styled.button`
  padding: 6px 12px;
  border: 1px solid ${colors.black};
  border-radius: 4px;
  background: ${colors.white};
  cursor: pointer;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  color: ${colors.black};
  &:hover {
    background-color: ${colors.gray4};
  }
`;
